import { InteractHomeIcon, InteractMoreActiveIcon, InteractMoreIcon, InteractSearchIcon } from '@/client/assets';
import { AuthedButton } from '@/client/components/authed-button';
import { MoreSlider } from '@/client/layouts/components/more-slider';
import { useAppSettingStore } from '@/client/store/app-store';
import { useModelStore } from '@/client/store/model-store';
import { cn } from '@/client/utils';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useMedia from 'react-use/lib/useMedia';
import { useLocation } from 'wouter';

export const NavMobile = () => {
  const isDesktop = useMedia('(min-width: 768px)');
  const { t } = useTranslation();
  const [location, navigate] = useLocation();
  const [openMoreSlider, setOpenMoreSlider] = useState(false);
  const baseToken = useAppSettingStore(state => state.baseToken);
  const setSearchOpen = useModelStore(state => state.setSearchOpen);
  const setWalletOpen = useModelStore(state => state.setWalletOpen);
  const navList = useMemo(
    () => [
      {
        icon: <InteractHomeIcon className="!size-6 fill-current" />,
        label: t('for-you'),
        active: location === '/',
        onClick: () => navigate('/'),
        isAuth: false,
      },
      {
        icon: <InteractSearchIcon className="!size-6 fill-current" />,
        label: t('search'),
        active: false,
        onClick: () => setSearchOpen(true),
        isAuth: false,
      },
      {
        icon: baseToken.assetsIcon ? <baseToken.assetsIcon className="!size-6 fill-current" /> : undefined,
        label: t('assets'),
        active: false,
        onClick: () => setWalletOpen(true),
        isAuth: true,
      },
      {
        icon: openMoreSlider ? (
          <InteractMoreActiveIcon className="!size-6 fill-current" />
        ) : (
          <InteractMoreIcon className="!size-6 fill-current" />
        ),
        label: t('more'),
        active: openMoreSlider,
        onClick: () => setOpenMoreSlider(true),
        isAuth: false,
      },
    ],
    [baseToken, location, navigate, openMoreSlider, setSearchOpen, setWalletOpen, t]
  );
  if (isDesktop) return null;
  return (
    <div className="w-full flex items-center justify-between py-2.5 pos-fixed bottom-0 z-30 border-t bg-card">
      {navList.map((nav, index) => {
        if (nav.isAuth) {
          return (
            <AuthedButton
              key={`auth-nav-${nav.label}-${index}`}
              variant="ghost"
              showAuth={false}
              showLoading={false}
              onClick={nav.onClick}
              className={cn(
                'w-1/4 flex flex-col items-center space-y-2 !p-0 !gap-0 h-full hover:bg-transparent',
                nav.active ? 'text-foreground' : 'text-foreground/70'
              )}
            >
              {nav.icon}
              <p className="text-xs font-medium leading-none truncate max-w-[90%]">{nav.label}</p>
            </AuthedButton>
          );
        }
        return (
          <dl
            key={`nav-${nav.label}-${index}`}
            onClick={nav.onClick}
            className={cn(
              'w-1/4 flex flex-col items-center space-y-2',
              nav.active ? 'text-foreground' : 'text-foreground/70'
            )}
          >
            <dt>{nav.icon}</dt>
            <dd className="text-xs font-medium leading-none">{nav.label}</dd>
          </dl>
        );
      })}
      <MoreSlider isOpen={openMoreSlider} setIsOpen={setOpenMoreSlider} />
    </div>
  );
};
